import { useState } from 'react'

import { Spin, Typography } from 'antd'

import { bindWechatApi } from '@eastcoal/api/auth/wechat/bindWechat'

import { DraggableModal } from '@eastcoal/common/components/DraggableModal'

import { ScanQrcode } from '../ScanQrcode'
import { ScanQrcodeProps } from '../ScanQrcode/interface'

import { BindWechatProps } from './interface'

export const BindWechat = ({
  onSuccess,
  /* -------------------------------------------------------------------------- */
  /*                            DraggableModal Props                            */
  /* -------------------------------------------------------------------------- */
  open,
  onOpenChange
}: BindWechatProps) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error>()

  const handleReload = () => {
    setError(undefined)
  }

  const handleScan: ScanQrcodeProps['onScan'] = async ({ bound, openId }) => {
    setError(undefined)
    if (bound) {
      setError(new Error('该微信已被绑定'))
      return
    }
    try {
      setLoading(true)
      const res = await bindWechatApi({ openId }, { silence: true })
      onSuccess?.(res)
    } catch (e) {
      setError(e as any)
    } finally {
      setLoading(false)
    }
  }

  return (
    <DraggableModal
      destroyOnHidden
      cancelText=''
      open={open}
      title='绑定微信'
      onOpenChange={onOpenChange}
    >
      <Spin description='绑定中...' spinning={loading}>
        <ScanQrcode
          bordered
          autoLogin={false}
          tip={
            error ? (
              <Typography.Text type='danger'>
                绑定失败: {error.message}
              </Typography.Text>
            ) : undefined
          }
          onReload={handleReload}
          onScan={handleScan}
        />
      </Spin>
    </DraggableModal>
  )
}
